// extracted by mini-css-extract-plugin
export default {"userName":"RenderTicket_userName__d8F6X"};